import {Component, OnInit} from '@angular/core';
import {AbstractDisplayComponent} from '../abstract-display.component';
import {CacheJsService, ConfiguratorI18nCacheService} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-affilie-display',
    templateUrl: './affilie-display.component.html',
    styleUrls: ['./affilie-display.component.scss'],
    standalone: false
})
export class AffilieDisplayComponent extends AbstractDisplayComponent implements OnInit {

    constructor(
        private readonly cacheJsService: CacheJsService,
        private readonly configuratorI18nCacheService: ConfiguratorI18nCacheService) {
        super();
    }

    ngOnInit() {
        this.display = this.value;
        this.displayHover = '...';
    }

    getTooltip() {
        const group = 'AFFI';
        if (this.cacheJsService.existKey(group)) {
            this.displayHover = this.cacheJsService.getValueByKey(group)[this.value];
        } else {
            this.configuratorI18nCacheService.searchClientToMapUsingGET().subscribe(map => {
                this.cacheJsService.addKeyValue(group, map);
                this.displayHover = map[this.value];
            });
        }
    }

}
